import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["month", "year", "dateparam"];

  async open(event) {
    this.emptyFrame();
    this.load_modal(event);
  }

  emptyFrame() {
    const frame = document.querySelector("#kalender");
    if (frame) {
      frame.innerHTML = "";
    }
  }

  async load_modal(event) {
    const url = event.params.url;
    const response = await get(url, { responseKind: "turbo-stream" });
    if (!response.ok) {
      console.error("Something went wrong.");
      return;
    }
  }

  async update(event) {
    const date = this.yearTarget.value + "-" + this.monthTarget.value + "-1";
    const response = await get(`${event.params.url}&start_date=${date}`, {
      responseKind: "turbo-stream",
    });
    if (!response.ok) {
      console.error("Something went wrong.");
      return;
    }
  }

  async wijzig_geselecteerde_datum(event) {
    event.preventDefault();
    const datum = `${event.params.jaar}-${String(event.params.maand).padStart(2, "0")}-${String(event.params.dag).padStart(2, "0")}`;
    document.getElementById(event.params.gekozenDatumInputId).value = datum
      .split("-")
      .reverse()
      .join("-");
    document.getElementById(event.params.gekozenDatumHiddenInputId).value =
      datum;
    this.closeModal();

    if (event.params.korteTermijn) {
      new bootstrap.Modal(document.getElementById("kortePlanningModal")).show();
    }

  }

  closeModal() {
    const elem = document.getElementById("kalenderModal");
    const modal = bootstrap.Modal.getInstance(elem);
    if (modal) {
      modal.hide();
    }
  }

  herOpenKalender() {
    const kortePlanningModal = bootstrap.Modal.getInstance(
      document.getElementById("kortePlanningModal")
    );
    if (kortePlanningModal) {
      kortePlanningModal.hide();
    }
    // Wacht tot de modal verborgen is voordat we de kalender openen
    document.getElementById("kortePlanningModal").addEventListener(
      "hidden.bs.modal",
      () => {
        new bootstrap.Modal(document.getElementById("kalenderModal")).show();
      },
      { once: true }
    );
  }

}
